angular.module('ikeweb.map').service('captureMapFactory', ['CaptureMap', 'ikeMapFactory',
    function(CaptureMap, ikeMapFactory) {
        this.create = function($element, center, captures) {
            return new CaptureMap(ikeMapFactory.create($element), center, captures);
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/capture/capture.map.factory.js
// module id = 589
// module chunks = 0